import DatePicker from "react-datepicker"
import { SelectPartner } from "@/features/partner"
import CalendarIcon from "@/shared/assets/images/CalendarBlank.svg"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { selectCurrentClientType, selectCurrentPartner, selectCurrentSearch, selectCurrentStore, selectEndDate, selectStartDate, setClientType, setEndDate, setSearch, setSelectedPartner, setSelectedStore, setStartDate } from "../../model"
import { Search } from "@/shared/ui/search"
import { Select } from "@/shared/ui/select/select"
import { selectStores, selectStoresLoading } from "@/entities/partner"
import { useMemo } from "react"
import { useSearchParams } from "react-router-dom"

const clientSelectOptions = [
    {
        value: null,
        label: "Все клиенты"
    },
    {
        value: "fiz",
        label: "Физические лица"
    },
    {
        value: "legal",
        label: "Юридические лица"
    }
]

export const TransactionsFilters = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const stores = useAppSelector(selectStores)
    const storesLoading = useAppSelector(selectStoresLoading)
    const selectedPartner = useAppSelector(selectCurrentPartner)
    const startDate = useAppSelector(selectStartDate)
    const search = useAppSelector(selectCurrentSearch)
    const clientType = useAppSelector(selectCurrentClientType)
    const store = useAppSelector(selectCurrentStore)
    const endDate = useAppSelector(selectEndDate)
    const dispatch = useAppDispatch()
    
    const storeSelectOptions = useMemo(() => [{
        label: 'Все торговые точки',
        value: null
    }, ...Object
        .entries(stores)
        .filter((([k]) => selectedPartner?.length ? k === selectedPartner[0] : true))
        .reduce((acc, [_, v]) => [...acc, ...v], [])
        .map(store => ({
            value: store.id,
            label: store.name ?? store.address ?? store.id
        }))
    ], [stores, selectedPartner])

    const handleChangeClientType = (value: "fiz" | "legal" | null) => {
        dispatch(setClientType(value))
    }

    const handleChangeStore = (value: string | null) => {
        dispatch(setSelectedStore(value))

        const nextSearchParams = new URLSearchParams(searchParams)
        if (value) {
            nextSearchParams.set("storeId", value)
        } else {
            nextSearchParams.delete("storeId")
        }
        setSearchParams(nextSearchParams, { replace: true })
    }
    
    const handleChangePartner = (value: string | null) => {
        dispatch(setSelectedPartner(value))

        const nextSearchParams = new URLSearchParams(searchParams)
        nextSearchParams.delete("storeId")
        setSearchParams(nextSearchParams, { replace: true })
    }

    const handleChangeSearch = (value: string) => {
        dispatch(setSearch(value.length ? value : null))
    }
    
    const handleDateRangeChange = (value: [Date, Date]) => {
        const [start, end] = value
        dispatch(setStartDate(start))
        dispatch(setEndDate(end))
    }

    return (
        <div className="grid grid-cols-12 gap-2">
            <div className="col-span-4 xxl:col-span-2">
                <Search value={search} onChange={handleChangeSearch} />
            </div>
            <div className="col-span-4 xxl:col-span-2">
                <SelectPartner value={selectedPartner?.[0] ?? null} onChange={handleChangePartner} />
            </div>
            <div className="col-span-4 xxl:col-span-2">
                <Select 
                    value={clientType}
                    onChange={handleChangeClientType}
                    options={clientSelectOptions}
                />
            </div>
            <div className="col-span-6 xxl:col-span-2">
                <Select 
                    value={store?.[0] ?? null}
                    onChange={handleChangeStore}
                    options={storeSelectOptions}
                    isLoading={storesLoading}
                />
            </div>
            <div className="col-span-6 xxl:col-span-4">
                <DatePicker 
                    selected={startDate}
                    startDate={startDate}
                    onChange={handleDateRangeChange}
                    endDate={endDate}
                    selectsRange
                    wrapperClassName="react-datepicker-filterlike"
                    dateFormat={"dd.MM.yyyy"}
                    showIcon
                    enableTabLoop={false}
                    popperProps={{
                        placement: 'bottom'
                    }}
                    icon={(<CalendarIcon width={24} height={24}/>)}
                />
            </div>
        </div>
    )
}
